<template>
  <div class="px-8 pt-8 pb-6">
    <ApprovalsPanelBackButton
      class="mb-4"
      @click="emit('back')"
    />

    <h2 class="text-h2 text-textDarkest mb-4">
      Update outdated job profiles
    </h2>

    <p class="text-body-1 text-textDark mb-0">
      {{ confirmUpdateCopy }}
    </p>
    <p class="text-body-1 text-textDark mt-4 mb-4">
      Each can be reverted individually from its version history, but there's no way to undo this
      in bulk.
      <a
        href="https://help.datapeople.io/article/369-jobnav-profile-templates"
        class="text-info"
        target="_blank"
        rel="noopener noreferrer"
      >Learn more here.</a>
    </p>

    <DpplNewButton
      color="primary"
      height="40"
      block
      @click="emit('confirm')"
    >
      Confirm update
    </DpplNewButton>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import ApprovalsPanelBackButton from '@/components/jobProfiles/editor/approvals/ApprovalsPanelBackButton.vue';
import DpplNewButton from '@/components/datapeople/DpplNewButton.vue';

const props = defineProps({
  selectedCount: {
    type: Number,
    default: 0,
  },
});

const emit = defineEmits(['back', 'confirm']);

const confirmUpdateCopy = computed(() => (
  props.selectedCount === 1
    ? 'This will update 1 profile with the current template content.'
    : `This will update ${props.selectedCount} profiles with the current template content.`
));
</script>
